module.exports = __webpack_public_path__ + "static/ferran-f92b8ef46a0b2f6553c0eb918a67fcac.jpg";